import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { queryClient } from '~app/query-client';

import { KEYS } from '~shared/api/query-keys';

import { baseAPI } from '../../../shared/api/base-api';

const deleteStripeCredentials = async (studioId: string) => {
  const response = await baseAPI.delete<unknown>(
    `payment-processor/credential/studio/${studioId}`,
  );
  return response.data;
};

export const useDeleteStripeCredentialsMutation = () => {
  return useMutation({
    mutationFn: deleteStripeCredentials,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.STRIPE, KEYS.CREDENTIALS],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.STRIPE_CREDENTIAL_ENVIRONMENT],
      });
      toast.success('Stripe integration removed successfully');
    },
  });
};
